module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('article', {
    staticClass: "comment-box media"
  }, [_c('router-link', {
    staticClass: "media-left",
    attrs: {
      "to": _vm.plink,
      "tag": "div"
    }
  }, [_c('player-avatar', {
    staticClass: "comment-box_user-image",
    attrs: {
      "player": _vm.comment.user.player
    }
  })], 1), _vm._v(" "), (!_vm.editing_comment) ? _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_c('router-link', {
    staticClass: "comment-box_user-name",
    attrs: {
      "to": _vm.plink,
      "tag": "strong"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.comment.user.player.name) + "\n        ")]), _vm._v("\n        -\n        "), _c('small', {
    staticClass: "comment-box_date"
  }, [_vm._v("\n          " + _vm._s(_vm._f("moment")(_vm.comment.created_at, "from", "now")) + "\n        ")])], 1), _vm._v(" "), _c('p', {
    staticClass: "comment-box_text",
    domProps: {
      "innerHTML": _vm._s(_vm.html_content)
    }
  })]), _vm._v(" "), (_vm.user.id === _vm.comment.user_id) ? _c('p', {
    staticClass: "comment-box_toolbar content"
  }, [_c('button', {
    staticClass: "button is-text is-text-danger",
    on: {
      "click": function($event) {
        _vm.editComment(_vm.comment)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.edit')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-text is-text-danger",
    on: {
      "click": function($event) {
        _vm.deleteComment(_vm.comment)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.delete')) + "\n      ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editing_comment) ? _c('form', {
    staticClass: "comment-form media-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save(_vm.comment)
      }
    }
  }, [_c('div', {
    staticClass: "control",
    class: {
      'is-loading': _vm.loading
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.new_comment),
      expression: "new_comment",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "textarea is-open-big",
    attrs: {
      "placeholder": _vm.$t('fields.add_comment')
    },
    domProps: {
      "value": (_vm.new_comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_comment = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comment-form_actions"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.new_comment),
      expression: "new_comment"
    }],
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.loading
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('buttons.send')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('buttons.cancel')) + "\n        ")])])])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5c2caf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hit/HitComment.vue
// module id = 370
// module chunks = 9